export default __webpack_public_path__ + "static/media/total_materiais-atlas-new.f51e3b0b.png";